import { render, staticRenderFns } from "./addOrUpdate.vue?vue&type=template&id=43c068f1&"
import script from "./addOrUpdate.vue?vue&type=script&lang=js&"
export * from "./addOrUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\jenkinsworkspace\\Aigo.B2CAdmin.Publish\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('43c068f1')) {
      api.createRecord('43c068f1', component.options)
    } else {
      api.reload('43c068f1', component.options)
    }
    module.hot.accept("./addOrUpdate.vue?vue&type=template&id=43c068f1&", function () {
      api.rerender('43c068f1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/seo/addOrUpdate.vue"
export default component.exports